// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/*defining styles*/\n.react-calendar-timeline .rct-vertical-lines .rct-vl.rct-day-0\n,.react-calendar-timeline .rct-vertical-lines .rct-vl.rct-day-6 {\n    background:transparent !important ;\n}\n\n.react-calendar-timeline .rct-sidebar .rct-sidebar-row{\n  border-left: 1px solid #bbbbbb;\n}\n\n.react-calendar-timeline .rct-sidebar .rct-sidebar-row{\n  padding: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
